import { FaMapMarkerAlt, FaEnvelope, FaPhoneAlt } from 'react-icons/fa';
import CTAButton from '../components/CTAButton';
import useDocumentTitle from '../hooks/useDocumentTitle';

const contactHeroImg = require('../Assert/11.jpg');

function Contact() {
  useDocumentTitle('Contact MMI');

  return (
    <main className="contact-page">
      <section className="contact-hero">
        <div className="container">
          <div className="contact-hero-grid">
            <div className="contact-hero-media">
              <div className="assert-image-wrap">
                <img src={contactHeroImg} alt="Contact MMI" className="assert-image" />
                <div className="assert-image-glow" aria-hidden="true" />
              </div>
            </div>
            <div className="contact-hero-text">
              <h1 className="hero-title">Got a Problem Worth Solving?</h1>
              <p className="hero-description">
                We don't do discovery calls that go nowhere. If you come with a real challenge, we come back with a real answer.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="contact-form-section" id="contact-form">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-info-wrap">
              <div className="contact-info-blob" aria-hidden>
                <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
                  <defs>
                    <linearGradient id="contactBlobGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                      <stop offset="0%" stopColor="rgba(122, 31, 162, 0.35)" />
                      <stop offset="100%" stopColor="rgba(236, 72, 153, 0.12)" />
                    </linearGradient>
                  </defs>
                  <path
                    fill="url(#contactBlobGrad)"
                    d="M45 110c-18-42 28-78 72-62 44 16 68 58 42 92-26 34-78 38-114 12-12-10-18-24-24-42z"
                  />
                </svg>
              </div>
              <div className="contact-info">
                <div className="info-item">
                  <FaMapMarkerAlt className="info-icon" />
                  <div>
                    <div className="info-label">OFFICE</div>
                    <div className="info-value">Bahria Town, Islamabad</div>
                  </div>
                </div>
                <div className="info-item">
                  <FaEnvelope className="info-icon" />
                  <div>
                    <div className="info-label">EMAIL</div>
                    <div className="info-value">innovate@mnminnovators.com</div>
                  </div>
                </div>
                <div className="info-item">
                  <FaPhoneAlt className="info-icon" />
                  <div>
                    <div className="info-label">PHONE</div>
                    <div className="info-value">03205352001</div>
                  </div>
                </div>
              </div>
            </div>

            <form
              className="contact-form"
              action="https://api.web3forms.com/submit"
              method="POST"
            >
              {/* REPLACE WITH REAL WEB3FORMS ACCESS KEY — Sign up at web3forms.com */}
              <input type="hidden" name="access_key" value="YOUR_ACCESS_KEY" />
              <input type="hidden" name="subject" value="New inquiry from MMI website" />

              <div className="form-group">
                <label className="form-label" htmlFor="contact-name">
                  Full Name
                </label>
                <input
                  type="text"
                  id="contact-name"
                  name="name"
                  className="form-input"
                  placeholder="Your name"
                  required
                />
              </div>
              <div className="form-group">
                <label className="form-label" htmlFor="contact-email">
                  Email
                </label>
                <input
                  type="email"
                  id="contact-email"
                  name="email"
                  className="form-input"
                  placeholder="you@company.com"
                  required
                />
              </div>
              <div className="form-group">
                <label className="form-label" htmlFor="contact-company">
                  Company Name
                </label>
                <input
                  type="text"
                  id="contact-company"
                  name="company"
                  className="form-input"
                  placeholder="Your company"
                />
              </div>
              <div className="form-group">
                <label className="form-label" htmlFor="contact-building">
                  What Are You Building?
                </label>
                <input
                  type="text"
                  id="contact-building"
                  name="building"
                  className="form-input"
                  placeholder="Agentic AI, AR/VR, platform, etc."
                />
              </div>
              <div className="form-group">
                <label className="form-label" htmlFor="contact-message">
                  Tell Us Everything
                </label>
                <textarea
                  id="contact-message"
                  name="message"
                  className="form-textarea"
                  placeholder="Goals, constraints, timeline — the more context, the better."
                  rows="5"
                  required
                ></textarea>
              </div>
              <button type="submit" className="submit-button">
                Send
              </button>
            </form>
          </div>
        </div>
      </section>

      <section className="contact-cta">
        <div className="container">
          <div className="cta-box">
            <h2 className="cta-title">
              The best time to build was ten years ago.
            </h2>
            <p className="cta-subtitle">
              The second best time is <span className="gradient-text">now.</span>
            </p>
            <CTAButton text="Book a Call" scrollTo="#contact-form" />
          </div>
        </div>
      </section>
    </main>
  );
}

export default Contact;
